
import { Component, Prop, Watch } from 'vue-property-decorator'
import Mixin from './../helpers/mixin'

@Component({
  template: `
    <div class="expand-item margin-on-phone" :class="{open}">
      <button class="flex" @click="open = !open">
        <h3>{{ title }}</h3>
        <i class="icons8-chevron-down ml-05"></i>
      </button>
      <div class="content-container" :style="{height: height}">
        <div ref="content">
          <slot></slot>
        </div>
      </div>
    </div>
  `
})
export default class ExpandItem extends Mixin {
  @Prop({ default: false }) initialOpen: boolean
  @Prop() title!: string
  @Prop( { default: 0 } ) extraMargin: number

  open: boolean = this.initialOpen
  realContentHeight = 0

  get height(): string {
    if (!this.$refs.content && this.open) return 'initial'
    if (this.open) return this.realContentHeight + 'px'
    return '0px'
  }

  setRealContentHeight(): void {
    this.realContentHeight = (this.$refs.content as HTMLElement).clientHeight + +this.extraMargin
  }

  created(): void {
    this.$nextTick(() => this.setRealContentHeight())
  }

  @Watch('isPhone')
  onIsPhoneChange() {
    this.setRealContentHeight()
  }

  @Watch('isTabletP')
  onIsTabletP() {
    this.setRealContentHeight()
  }
}
